import { type Dispatch, type SetStateAction } from 'react'

import { Button } from 'slab'

import { type EmployerFilters } from './EmployerReviewsTable'

type EmployerReviewsQuickFiltersProps = {
  filters: EmployerFilters
  setFilters: Dispatch<SetStateAction<EmployerFilters>>
}

function setPendingFilters (
  setFilters: Dispatch<SetStateAction<EmployerFilters>>
) {
  setFilters(() => ({
    review_statuses: ['pending'],
  }))
}

function setApprovedFilters (
  setFilters: Dispatch<SetStateAction<EmployerFilters>>
) {
  setFilters(() => ({
    review_statuses: ['approved'],
  }))
}

function setBangorFilters (
  setFilters: Dispatch<SetStateAction<EmployerFilters>>
) {
  setFilters(() => ({
    bank_partners: ['Bangor'],
  }))
}

function setDeniedFilters (
  setFilters: Dispatch<SetStateAction<EmployerFilters>>
) {
  setFilters(() => ({
    review_statuses: ['denied'],
  }))
}

function setAllFilters (
  setFilters: Dispatch<SetStateAction<EmployerFilters>>
) {
  setFilters(() => ({}))
}

const EmployerReviewsQuickFilters = ({
  setFilters,
}: EmployerReviewsQuickFiltersProps) => {
  return (
    <div className='ml-1 flex items-center justify-start gap-2 flex-shrink-0 flex-wrap'>
      <div className='text-sm font-semibold min-w-16'>Quick filters</div>
      <Button
        variant='tertiary'
        onClick={() => setPendingFilters(setFilters)}
      >
        Waiting for Review
      </Button>
      <Button
        variant='tertiary-deemphasized'
        onClick={() => setApprovedFilters(setFilters)}
      >
        Approved
      </Button>
      <Button
        variant='tertiary-deemphasized'
        onClick={() => setBangorFilters(setFilters)}
      >
        Onboarding to Bangor
      </Button>
      <Button
        variant='tertiary-deemphasized'
        onClick={() => setDeniedFilters(setFilters)}
      >
        Denied
      </Button>
      <Button
        variant='tertiary-deemphasized'
        onClick={() => setAllFilters(setFilters)}
      >
        All
      </Button>
    </div>
  )
}

export default EmployerReviewsQuickFilters
